import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { CorePromise } from './components/CorePromise';
import { Comparison } from './components/Comparison';
import { ProductStack } from './components/ProductStack';
import { MaterialCarousel } from './components/MaterialCarousel';
import { Bonuses } from './components/Bonuses';
import { OfferBox } from './components/OfferBox';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { GuaranteeClose } from './components/GuaranteeClose';
type AppProps = {
  mostrarBannerUrgencia?: boolean;
  minutosDeOferta?: number;
};
export function App({
  mostrarBannerUrgencia = true,
  minutosDeOferta = 12
}: AppProps) {
  return <div className="min-h-full w-full bg-ink font-sans" data-id="element-0" data-mp="28sutulzptvl7">
      {mostrarBannerUrgencia ? <UrgencyBanner minutosIniciales={minutosDeOferta} data-id="element-1" data-mp="23u9vks40xlze" /> : null}
      <main data-id="element-2" data-mp="3ik7fqfdqo9q4">
        <Hero data-id="element-3" data-mp="3ikh5c1uvgeva" />
        <SocialProof data-id="element-4" data-mp="3iiwfgpji5k3r" />
        <CorePromise data-id="element-5" data-mp="3ijftvw9y1qd1" />
        <Comparison data-id="element-6" data-mp="3ii4s22026sok" />
        <ProductStack data-id="element-7" data-mp="3mlax56bfqdtg" />
        <MaterialCarousel data-id="element-8" data-mp="3mkhlbqxmcy4g" />
        <Bonuses data-id="element-9" data-mp="3mjq1fdddwou0" />
        <OfferBox data-id="element-10" data-mp="3mj6ibtbzzuee" />
        <Testimonials data-id="element-11" data-mp="3rcj5s04xxv5k" />
        <FAQ data-id="element-12" data-mp="3rbznujfaj6rj" />
      </main>
      <GuaranteeClose data-id="element-13" data-mp="3rcsw5otwe4bs" />
    </div>;
}